import React from "react";
import "./HomeSec2.css";

const HomeSec2 = () => {
  return (
    <div>
      <div>
        <div className="container-fluid main2">
          {/* <img className='img-j'src='./bg-4.png'alt='hhh'/> */}
          {/* <div className='row kk2'>

            </div> */}

          <div className="row k2">
            <div className="col-12 py-4"></div>
            <div className="col-2 m2">
              <img className="ele2" src="elephnt 2.png" alt="hhh" />
            </div>
            <div className="col-8 text-center">
              <p className="para_12">WHAT MAKES</p>
              <p className="para_22">SURYA VILAS PALACE</p>
              <p className="para_32">SO SPECIAL?</p>
            </div>
            <div className="col-2">
              <img className="ele2" src="elephnt 2.png" alt="hhh" />
            </div>
          </div>
          <div className="row kkk2">
            <div className="col-12 py-md-2"></div>
            <div className="col-2"></div>
            <div className="col-9 mm2">
              <div className="row">
                <div className="col-4 mmm2">
                  {/* <div className=""> */}
                  <img className="img-s2" src="./image 143.png" alt="hhh" />
                  {/* </div> */}
                  <p className="para_52">1982</p>
                </div>
                <div className="col-7 nn2">
                  <div className="jjj2-container">
                    <img className="jjj2" src="./image 144.png" alt="hhh" />
                  </div>
                  <div className="row">
                    <div className="col-1"></div>
                    <div className="col-9">
                      <p className="para_42">
                        Lorem ipsum dolor sit amet consectetur. Adipiscing
                        lectus sit sit sed semper vitae faucibus consequat. Sed
                        dui auctor aliquam quam urna magna feugiat egestas
                        placerat. Pharetra arcu nulla lacus molestie quis
                        dignissim quis tempor interdum. Quam blandit iaculis
                        ante pellentesque lectus viverra tristique ultrices.
                        Adipiscing purus mattis leo sit mi id sed.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-1"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSec2;
